<div class="pwa-prompt" *ngIf="this.isIos && !this.isRunningAsPWA">
  <p *ngIf="!this.clicked">{{"pwa.explanation" | translate}}</p>
  <p *ngIf="this.clicked">{{"pwa.followInstructions" | translate}}</p>
  <div *ngIf="!this.clicked">
    <button mat-raised-button color="primary" (click)="navigateToIOSInstructions()">{{"pwa.install" | translate}}</button>
  </div>
  <button class="close" onclick="document.querySelector('.pwa-prompt').style.display='none';">&times;</button>
</div>
